import React from 'react'
import {Icon, Button} from '../../components'
import './index.css'
import { downloadFile } from '../../services/files';
interface FileDownloaderProps {
    file: { 
        id: number,
        name: string,
        url: string,
        createdAt?: string
    };
    date?: string,
    deleteFile?: Function,
    label?: string,
    width?: number,
    height?: number
}

export const FileDownloader = ({
    file,
    deleteFile,
    label,
    width = 60,
    height = 60,
    date
}: FileDownloaderProps) => {
    const handleClick = () => {
        downloadFile(file.id);
    }

    const handleDelete = async () => {
        if(deleteFile){
            try {
                await deleteFile();
            } catch (error) {
                throw error;
            }
        }
    }

  return (
    <>
        {label && 
            <span className="label sm">
                {label}
            </span>
        }
        <div className="flex justify-between items-center rounded-lg border border-grey-light p-3">
            <div className="flex items-center">
                <div className="icon-bg-orange relative mr-2" style={{width: `${width}px`, height: `${height}px`}}>
                    <Icon name="Cloud" className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2" width={30}/>
                </div>
                <div>
                    <p className="font-medium block">
                        {file?.name}
                    </p>
                    {!!date &&
                        <p className="text-grey-text block">
                            {date}
                        </p>
                    }
                </div>
            </div>
            <div className="flex items-center">
                {deleteFile && <Icon name="Trash" className="mr-2" onClick={handleDelete} />}
                <Button handleClick={handleClick} textColor="blue" className="flex items-center hover:underline text-blue"> <Icon name="ArrowBottomBlue" className="mr-2" height={12} /> Descargar</Button>
            </div>
        </div>
    </>
  )
}
